import { createClasses } from '@ahd/shared/tools/create-classes';

export const iconifyClasses = {
    root: createClasses('iconify__root'),
};
